export const MAX_UPLOAD_MEGABYTES = 24;
export const MAX_UPLOAD_BYTES = MAX_UPLOAD_MEGABYTES * 1024 * 1024;

